/* import libraries */
import { useState, useEffect, useRef } from "react";

/* import components */
import Button from "react-bootstrap/Button";
import OverlayTrigger from "react-bootstrap/OverlayTrigger"
import Tooltip from "react-bootstrap/Tooltip"
import Loading from "./Spinner";
import { LOST_ITEM_ARTICLE_ID } from "./variables/variables";

/* import services */
import { showButtonByTime } from "../utils/utils";

const ArticleInfo = (props) => {

    const [show, setShow] = useState(true);
    const targetRef = useRef(null);

    const handleContactDriver = () => {
        window.location.href = `ryde://open?action=lostItemContactDriver&tripId=${props.trip.id}`;
    }

    const handleOutsideClick = (e) => {
        if (targetRef.current && !targetRef.current.contains(e.target)) {
          setShow(false);
          props.setBgColor("#ffffff")
        }
    };

    useEffect(() => {
        if (props.article?.id === LOST_ITEM_ARTICLE_ID && showButtonByTime((props.trip?.time ? props.trip.time : props.trip?.rideStartTime), props.topic?.chatTime > 0 ? props.topic?.chatTime : 0)) {
            props.setBgColor("#272727");
        }
        document.addEventListener("mousedown", handleOutsideClick);
        return () => {
            document.removeEventListener("mousedown", handleOutsideClick);
        };
    }, [props.article]);

    if (!props.article) return (
          <Loading />
    );

    return (
        <>  
            <div className="alignTextDiffSize">
                <h3 className="grey font-bold" style={{ fontSize: "16px", paddingTop:"15px" }}>
                    {props.article?.name}
                </h3>
                {props.article?.id === LOST_ITEM_ARTICLE_ID && showButtonByTime((props.trip?.time ? props.trip.time : props.trip?.rideStartTime), props.topic?.chatTime > 0 ? props.topic?.chatTime : 0) ? 
                <OverlayTrigger
                    trigger="click"
                    placement="bottom"
                    show={show}
                    rootClose
                    overlay={
                        <Tooltip id="tooltip-top" style={{fontSize: '12px'}}>
                            Chat with your driver within {props.topic?.chatTime} hours to get your lost items back
                        </Tooltip>
                    }
                >
                    <span 
                        ref={targetRef} 
                        className="font-semibold" 
                        style={{ float: "right", color:"#E93864" }} 
                        onClick={handleContactDriver}>
                        Contact Driver
                    </span>
                </OverlayTrigger>
                : <></>}
            </div>
            <div className="grey articleContent" dangerouslySetInnerHTML={{__html: props.article?.body}} /> 
            {props.article?.formData ? 
            <>
                <Button 
                    className="ryde-button"
                    style={{ fontSize: "14px", marginTop: "1.5rem"}}
                    onClick={() => props.setPage("help-form")}>
                        Submit a Support Ticket
                </Button><br/><br/>
            </> : <></>}
        </>
        );
  }

  export default ArticleInfo;